import React, { Component } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import * as GServ from '../services/GatewayService';
import { CircularProgress, Button, TextField } from '@material-ui/core';


class PrimeEntry extends Component {
    constructor(props) {
        super(props);
        this.state = {
            canSubmit: false,
            emailPlaceholder: 'email address',
            emailValue: '',
            status: '',
            warning: '',
            captcha_response: null,
            showSpinner: false,
            server_error: false,
            email_exists: false,
            has_active_app: false,
        }

    }

    componentDidMount = () => {
        // window.parent.location.href = 'https://payfast.co.za'
        GServ.pingServers();
    };
        
    render() {
        return (
            <div>

                <h2>Welcome!</h2>
                <p>To get started, please type in your <b>email address</b> below. <br/>
                    We'll use this email address to make contact with you in connection with your {this.props.qparms.operation==='register'? 'course' : 'application'}.</p>
                <hr/>
                <form onSubmit={this.submitHandler}>                
                    {/* <div className="prime_input"> */}
                    <TextField 
                        type='email'
                        variant='outlined'
                        // color='primary'
                        disabled={this.state.showSpinner}
                        // placeholder="email address"
                        label="email address"
                        autoFocus={true}
                        onChange={this.handleEmailUpdate}
                        value={this.state.emailValue}
                        autoComplete='off'
                        autoCorrect='off'
                        autoCapitalize='off'
                        style={{width:'40%', minWidth:'250px', marginTop:'10px'}}
                        // onFocus={()=>{this.setState({emailPlaceholder:'',status:''});}}
                        // onBlur={()=>{this.setState({emailPlaceholder:'email address'});}}
                    />

                        {/* <input type='email' disabled={this.state.showSpinner} autoFocus={true} placeholder={this.state.emailPlaceholder} onChange={this.handleEmailUpdate} value={this.state.emailValue} autoComplete='off' autoCorrect='off' autoCapitalize='off' onFocus={()=>{this.setState({emailPlaceholder:'',status:''});}} onBlur={()=>{this.setState({emailPlaceholder:'email address'});}} />
                            */}

                    {/* </div> */}
                    <br/>
                    <div className='captchaPanel'>
                        <ReCAPTCHA
                            sitekey="6Lfr98AUAAAAACxdLReRa6v8SMYWxxFrsfthpFiv"
                            onChange={this.verifyCallback}
                            onExpired={()=>this.setState({canSubmit:false})}
                        />
                    </div>
                    <br/>
                    <Button 
                        variant='contained'
                        color='primary'
                        size='large'
                        id='Submit'
                        type='submit'
                        disabled={!this.state.canSubmit}
                        style={{marginTop:'15px'}}
                    >
                        Submit
                    </Button>
                    {/* <button id="Submit" className="button" style={{verticalAlign:'middle'}} disabled={!this.state.canSubmit}><span id="s1" >Submit</span></button> */}
                </form>
                <hr/>
                <span id="StatusBar" className="StatusBar">
                    {this.state.showSpinner&&<CircularProgress size={30} />}&nbsp;&nbsp;
                    {this.state.status}
                </span>
                <span className='warningMessage'>{this.state.warning}</span>
                
            </div>
        );
    }

    submitHandler = (e) => {
        e.preventDefault();
        // console.log('Called validate email...');
        if (this.state.emailValue === '') {
            this.setState({status:'Please provide an email address...'});
            return false;
        } else {
            this.setState({status:'Processing...',showSpinner:true,canSubmit:false,warning:''});
            // console.log('Email ok... processing')
            GServ.prime_email_submit(this.state.captcha_response,this.state.emailValue,this.props.qparms)
            .then(reply => {
                // console.log('Server Reply => ',reply);
                if (reply.Result!=="Success"){
                    // console.log('Server reply @ prime_email_submit return => ',reply);
                    let warnMessage = '';
                    if (reply.Message === 'Form not open for entry'){
                        warnMessage = 'The selected application form is not currently open for entry. Should you have any queries, please contact us.';
                    } else {
                        warnMessage = 'Technical error encountered - if this problem persists, please contact us.';
                    }
                    this.setState({status:'',warning:warnMessage,showSpinner:false,server_error:true,canSubmit:true});
                } else {
                    //send gwt up to parent...
                    this.props.setParentState({
                        gwt:reply.GWT,
                        institution_name:reply.institution_name,
                        info_email:reply.info_email,
                        domain:reply.domain,
                        contact_phone:reply.contact_phone,
                        application_for:reply.application_for,
                        paygate:reply.paygate,
                        auto_register:reply.auto_register,
                        paygate_url: reply.paygate_url,
                        paygate_amount : reply.paygate_amount,
                        paygate_item : reply.paygate_item,
                        require_said: reply.require_said,
                        custom_otp_message: reply.custom_otp_message
                    });

                    if (reply.Status==="Email already in SIS") {
                        // console.log('reply from server - already in system => ',reply);
                        
                        //Check if there's a flag on this email...
                        if (reply.flags){
                            // console.log('Flags identified...');
                            if (reply.flags.offline_verification_required){
                                //offline verification required...
                                this.props.setParentState({showPrime:false,showRegret:true});
                            } else {
                                // some other flag(s) identified...
                                this.props.setParentState({showPrime:false,showRegret:true});
                            }
    
                        } else {
                            //Email is in the system but no flag - need to verify with OTP and then continue depending on whether we already have ID on file etc...
                            this.props.setParentState({
                                email:this.state.emailValue,
                                id_on_file:reply.has_id,
                                may_reapply_on_form:reply.may_reapply_on_form,
                                showPrime:false,
                                showOTPDialogue:true});
                        }
                    } else {
                        //email is new, can carry on...
                        this.props.setParentState({email:this.state.emailValue,showPrime:false,showNameNum:true});
                    }
                }
            });
            return true;
        }
    }

    handleEmailUpdate = (e) => {
        this.setState({emailValue:e.target.value})
    }

    // specifying your onload callback function
    expCallback = () => {
        console.log('Captcha expired...');
        this.setState({canSubmit:false,captcha_response:null});
    };
  
    // specifying verify callback function
    verifyCallback = (response) => {
        // console.log('Captcha respone',response);
        // GServ.pingServers();
        this.setState({captcha_response:response,canSubmit:true});
    };
    
}

export default PrimeEntry;